var _desc, _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExhibit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, "Point de vente") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "d"
  }, "Comptoir isometrique, terminal de paiement et carte.")), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n  :root{\n    --line:#025D7D;\n    --accent:#30C5E5;\n  }\n  @media (prefers-color-scheme: dark){\n    :root{ --line:#7FD8EE; --accent:#30C5E5; }\n  }\n  .e   {fill:none;stroke:var(--line);stroke-width:2.6;stroke-linecap:round;stroke-linejoin:round}\n  .e2  {fill:none;stroke:var(--line);stroke-width:1.9;stroke-linecap:round;stroke-linejoin:round;opacity:.7}\n  .e3  {fill:none;stroke:var(--line);stroke-width:1.2;stroke-linecap:round;opacity:.34}\n  .h   {fill:none;stroke:var(--line);stroke-width:1.2;stroke-linecap:round;opacity:.22;stroke-dasharray:4 6}\n  .a   {fill:none;stroke:var(--accent);stroke-width:2.8;stroke-linecap:round;stroke-linejoin:round}\n  .a2  {fill:none;stroke:var(--accent);stroke-width:1.9;stroke-linecap:round;stroke-linejoin:round;opacity:.75}\n  .face {fill:var(--accent);opacity:.07;stroke:none}\n  .face2{fill:var(--accent);opacity:.16;stroke:none}\n  .faceL{fill:var(--line);opacity:.07;stroke:none}\n  .dot  {fill:var(--accent)}\n  .dotl {fill:var(--line);opacity:.45}\n  .txt  {fill:var(--line);font-family:Montserrat,'Helvetica Neue',Arial,sans-serif;font-weight:700}\n  .txta {fill:var(--accent);font-family:Montserrat,'Helvetica Neue',Arial,sans-serif;font-weight:700}\n  .halo {fill:var(--accent);opacity:.16;transform-box:fill-box;transform-origin:center;\n         animation:pulse 3.4s ease-in-out infinite}\n  .flow {stroke-dasharray:6 10;animation:flow 2.6s linear infinite}\n  .flow2{stroke-dasharray:4 8;animation:flow 3.4s linear infinite reverse}\n  .drift{transform-box:fill-box;transform-origin:center;\n         animation:drift 6s ease-in-out infinite}\n  #scene{animation:float 8s ease-in-out infinite}\n  @keyframes pulse{0%,100%{transform:scale(.62);opacity:.09}50%{transform:scale(1.32);opacity:.34}}\n  @keyframes flow {to{stroke-dashoffset:-32}}\n  @keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-7px)}}\n  @keyframes drift{0%,100%{transform:translate(0,0)}50%{transform:translate(0,-9px)}}\n  @media (prefers-reduced-motion: reduce){*{animation:none !important}}\n  .d0{animation-delay:0.0s}\n  .d1{animation-delay:0.1s}\n  .d2{animation-delay:0.2s}\n  .d3{animation-delay:0.3s}\n  .d4{animation-delay:0.4s}\n  .d5{animation-delay:0.5s}\n  .d6{animation-delay:0.6s}\n  .d7{animation-delay:0.7s}\n  .d8{animation-delay:0.8s}\n  .d9{animation-delay:0.9s}\n  .d10{animation-delay:1.0s}\n  .d11{animation-delay:1.1s}\n  .d12{animation-delay:1.2s}\n  .d13{animation-delay:1.3s}\n  .d14{animation-delay:1.4s}\n  .d15{animation-delay:1.5s}\n  .d16{animation-delay:1.6s}\n  .d17{animation-delay:1.7s}\n  .d18{animation-delay:1.8s}\n  .d19{animation-delay:1.9s}\n  .d20{animation-delay:2.0s}\n  .d21{animation-delay:2.1s}\n  .d22{animation-delay:2.2s}\n  .d23{animation-delay:2.3s}\n  .d24{animation-delay:2.4s}\n  .d25{animation-delay:2.5s}\n  .d26{animation-delay:2.6s}\n  .d27{animation-delay:2.7s}\n  .d28{animation-delay:2.8s}\n  .d29{animation-delay:2.9s}\n  .d30{animation-delay:3.0s}\n  .d31{animation-delay:3.1s}\n  .d32{animation-delay:3.2s}\n  .d33{animation-delay:3.3s}\n  .d34{animation-delay:3.4s}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "scene"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e3",
    d: "M 250.3 166.5 L 456.1 285.3 L 261.7 397.5 L 55.9 278.7 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 238.9,
    y1: 199.5,
    x2: 113.1,
    y2: 272.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 278.9,
    y1: 222.6,
    x2: 153.1,
    y2: 295.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 318.9,
    y1: 245.7,
    x2: 193.1,
    y2: 318.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 358.9,
    y1: 268.8,
    x2: 233.1,
    y2: 341.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 398.9,
    y1: 291.9,
    x2: 273.1,
    y2: 364.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 238.9,
    y1: 199.5,
    x2: 398.9,
    y2: 291.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 196.9,
    y1: 223.7,
    x2: 357,
    y2: 316.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 155,
    y1: 247.9,
    x2: 315.1,
    y2: 340.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "e3",
    x1: 113.1,
    y1: 272.1,
    x2: 273.1,
    y2: 364.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 364.6 262.2 L 278.9 311.7 L 278.9 344.7 L 364.6 295.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 147.4 235.8 L 278.9 311.7 L 278.9 344.7 L 147.4 268.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 233.1 186.3 L 364.6 262.2 L 278.9 311.7 L 147.4 235.8 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 233.1,
    y1: 219.3,
    x2: 233.1,
    y2: 186.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 233.1,
    y1: 219.3,
    x2: 364.6,
    y2: 295.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "h",
    x1: 233.1,
    y1: 219.3,
    x2: 147.4,
    y2: 268.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 233.1 186.3 L 364.6 262.2 L 278.9 311.7 L 147.4 235.8 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 364.6,
    y1: 262.2,
    x2: 364.6,
    y2: 295.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 278.9,
    y1: 311.7,
    x2: 278.9,
    y2: 344.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 147.4,
    y1: 235.8,
    x2: 147.4,
    y2: 268.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 364.6,
    y1: 295.2,
    x2: 278.9,
    y2: 344.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    x1: 278.9,
    y1: 344.7,
    x2: 147.4,
    y2: 268.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 304.6 251.3 L 264.6 274.4 L 264.6 283.6 L 304.6 260.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "faceL",
    d: "M 196 234.8 L 264.6 274.4 L 264.6 283.6 L 196 244.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face",
    d: "M 236 211.7 L 304.6 251.3 L 264.6 274.4 L 196 234.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "M 236 211.7 L 304.6 251.3 L 264.6 274.4 L 196 234.8 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 304.6,
    y1: 251.3,
    x2: 304.6,
    y2: 260.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 264.6,
    y1: 274.4,
    x2: 264.6,
    y2: 283.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 196,
    y1: 234.8,
    x2: 196,
    y2: 244.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 304.6,
    y1: 260.6,
    x2: 264.6,
    y2: 283.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "e2",
    x1: 264.6,
    y1: 283.6,
    x2: 196,
    y2: 244.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 196 234.8 L 264.6 274.4 L 264.6 205.1 L 196 165.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 196 234.8 L 264.6 274.4 L 264.6 205.1 L 196 165.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 203.1 230 L 257.4 261.4 L 257.4 210.2 L 203.1 178.9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a2",
    d: "M 203.1 230 L 257.4 261.4 L 257.4 210.2 L 203.1 178.9 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a2",
    x1: 211.1,
    y1: 221.1,
    x2: 244.9,
    y2: 240.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "a2",
    x1: 211.1,
    y1: 207.9,
    x2: 244.9,
    y2: 227.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "a2",
    x1: 211.1,
    y1: 194.7,
    x2: 244.9,
    y2: 214.2
  }), /*#__PURE__*/React.createElement("g", {
    className: "drift d6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "face2",
    d: "M 347.5 202.8 L 387.5 225.9 L 358.9 242.4 L 318.9 219.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M 347.5 202.8 L 387.5 225.9 L 358.9 242.4 L 318.9 219.3 Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a2",
    x1: 346,
    y1: 209.9,
    x2: 361.7,
    y2: 219
  })), /*#__PURE__*/React.createElement("line", {
    className: "a2 flow",
    x1: 273.1,
    y1: 232.5,
    x2: 330.3,
    y2: 219.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "halo d4",
    cx: 230.3,
    cy: 186.3,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot",
    cx: 230.3,
    cy: 186.3,
    r: 3.8
  })), /*#__PURE__*/React.createElement("circle", {
    className: "dot drift d0",
    cx: 118,
    cy: 128,
    r: 3.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dotl drift d11",
    cx: 398,
    cy: 150,
    r: 4.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot drift d20",
    cx: 424,
    cy: 322,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dotl drift d6",
    cx: 92,
    cy: 306,
    r: 2.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dot drift d26",
    cx: 352,
    cy: 96,
    r: 2.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dotl drift d13",
    cx: 128,
    cy: 402,
    r: 2.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExhibit);
export default __webpack_public_path__ + "static/media/exhibit.822a17c5f74ce828035a8e75bef555cc.svg";
export { ForwardRef as ReactComponent };